/**

 * Ray's Loyalty — global reward notifications (toast + gift modal).

 */

(function () {

  'use strict';

  if (window.__RAYS_LOYALTY_NOTIFY_INITIALIZED__) return;
  window.__RAYS_LOYALTY_NOTIFY_INITIALIZED__ = true;



  var GIFT_KINDS = {

    birthday_bonus: true,

    birthday_gift_card: true,

    registration_bonus: true,

    monthly_tier_grant: true,

    monthly_vip_coupon: true,

  };



  var queue = [];

  var showing = false;

  var pollTimer = null;
  var pollRequest = null;

  var lastVisitToastAt = 0;

  var recentVisitAckIds = {};

  var presentedRegistrationIds = {};

  var registrationFlowCompleted = false;



  function registrationDoneKey() {

    var cid = customerId();

    return cid ? 'rl_reg_welcome_v1:' + cid : '';

  }



  function isRegistrationFlowCompleted() {

    if (registrationFlowCompleted) return true;

    try {

      var k = registrationDoneKey();

      return !!(k && sessionStorage.getItem(k) === '1');

    } catch (e) {

      return false;

    }

  }



  function markRegistrationFlowCompleted() {

    registrationFlowCompleted = true;

    try {

      var k = registrationDoneKey();

      if (k) sessionStorage.setItem(k, '1');

    } catch (e) {}

  }



  function markRegistrationPresented(dto) {

    if (dto && dto.id) presentedRegistrationIds[dto.id] = true;

  }



  function shouldSkipRegistrationNotification(dto) {

    if (!dto || dto.kind !== 'registration_bonus') return false;

    if (isRegistrationFlowCompleted()) return true;

    if (dto.id && presentedRegistrationIds[dto.id]) return true;

    return false;

  }



  function readConfig() {

    var node = document.getElementById('rl-notify-config');

    if (!node) {

      return {

        enabled: true,

        pollIntervalMs: 60000,

        templates: {},

        giftTitles: {},

        welcomeSignup: {},

      };

    }

    try {

      return JSON.parse(node.textContent || '{}');

    } catch (e) {

      return {

        enabled: true,

        pollIntervalMs: 60000,

        templates: {},

        giftTitles: {},

        welcomeSignup: {},

      };

    }

  }



  function customerId() {

    var c = window.__RAYS_LOYALTY__ && window.__RAYS_LOYALTY__.customerId;

    return c != null && c !== '' ? String(c) : '';

  }



  function isLoggedIn() {

    if (customerId()) return true;

    if (window.RaysLoyalty && window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {

      window.RaysLoyalty.syncStorefrontTokenFromWebComponents();

    }

    return !!customerId();

  }



  function formatPoints(n) {

    var v = Math.max(0, Math.floor(Number(n) || 0));

    try {

      return v.toLocaleString();

    } catch (e) {

      return String(v);

    }

  }



  function formatMoneyCents(cents) {

    var n = Number(cents);

    if (!isFinite(n)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {

      try {

        return window.Shopify.formatMoney(n, window.theme && window.theme.moneyFormat);

      } catch (e) {}

    }

    return (n / 100).toFixed(2);

  }



  function discountLabel(payload) {

    payload = payload || {};

    if (payload.discountType === 'percent' && Number(payload.discountPercent) > 0) {

      return String(Math.floor(Number(payload.discountPercent))) + '% off';

    }

    if (payload.discountType === 'fixed' && Number(payload.discountFixedAmountCents) > 0) {

      return formatMoneyCents(payload.discountFixedAmountCents) + ' off';

    }

    return 'VIP';

  }



  function formatExpiry(value) {

    if (!value) return '';

    var date = new Date(value);

    if (!isFinite(date.getTime())) return '';

    try {

      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {

        month: 'short',

        day: 'numeric',

        year: 'numeric',

      }).format(date);

    } catch (e) {

      return date.toLocaleDateString();

    }

  }



  function copyText(value) {

    var text = String(value || '');

    if (!text) return Promise.reject(new Error('empty_coupon'));

    if (window.RaysLoyalty && typeof window.RaysLoyalty.copyToClipboard === 'function') {

      return Promise.resolve(window.RaysLoyalty.copyToClipboard(text));

    }

    if (navigator.clipboard && navigator.clipboard.writeText) {

      return navigator.clipboard.writeText(text);

    }

    return Promise.reject(new Error('clipboard_unavailable'));

  }



  function applyPlaceholders(text, dto, extra) {

    var out = String(text || '');

    var payload = (dto && dto.payload) || {};

    var points = payload.points != null ? payload.points : 0;

    out = out.split('[[points]]').join(formatPoints(points));

    out = out.split('[[amount]]').join(formatMoneyCents(payload.amountCents));

    out = out.split('[[discount]]').join(discountLabel(payload));

    out = out.split('[[code]]').join(String(payload.discountCode || ''));

    out = out.split('[[expires]]').join(formatExpiry(payload.expiresAt));

    if (dto && dto.title) {

      out = out.split('[[title]]').join(String(dto.title));

    }

    if (extra) {

      if (extra.storeCreditAmount != null) {

        out = out.split('[[store_credit]]').join(String(extra.storeCreditAmount));

      }

      if (extra.pointsCost != null) {

        out = out.split('[[cost]]').join(formatPoints(extra.pointsCost));

      }

    }

    return out;

  }



  function messageFor(dto, cfg, extra) {

    var kind = dto && dto.kind ? String(dto.kind) : '';

    var tpl =

      (cfg.templates && cfg.templates[kind]) ||

      (cfg.templates && cfg.templates.default) ||

      dto.title ||

      '';

    return applyPlaceholders(tpl, dto, extra);

  }



  function giftTitleFor(dto, cfg) {

    var kind = dto && dto.kind ? String(dto.kind) : '';

    return (

      (cfg.giftTitles && cfg.giftTitles[kind]) ||

      dto.title ||

      ''

    );

  }



  function ackIds(ids) {

    if (!ids.length || !window.RaysLoyalty || !window.RaysLoyalty.ackRewardNotifications) {

      return Promise.resolve();

    }

    return window.RaysLoyalty.ackRewardNotifications(ids).catch(function () {});

  }



  function showToastEl(text, isError) {

    var root = document.getElementById('rl-notify-root');

    var toast = document.getElementById('rl-notify-toast');

    if (!root || !toast) return Promise.resolve();

    root.hidden = false;

    var textEl = toast.querySelector('.rl-notify-toast__text');

    if (textEl) textEl.textContent = text;

    toast.classList.toggle('rl-notify-toast--error', !!isError);

    toast.hidden = false;

    return new Promise(function (resolve) {

      window.setTimeout(function () {

        toast.hidden = true;

        if (!document.getElementById('rl-notify-gift') || document.getElementById('rl-notify-gift').hidden) {

          root.hidden = true;

        }

        resolve();

      }, isError ? 4000 : 3200);

    });

  }



  function bindGiftClose(gift, onClose) {

    function close() {

      gift.hidden = true;

      document.body.classList.remove('rl-notify-gift-open');

      var root = document.getElementById('rl-notify-root');

      if (root) root.hidden = true;

      gift.querySelectorAll('[data-rl-notify-gift-close]').forEach(function (el) {

        el.removeEventListener('click', onCloseHandler);

      });

      onClose();

    }

    function onCloseHandler() {

      close();

    }

    gift.querySelectorAll('[data-rl-notify-gift-close]').forEach(function (el) {

      el.addEventListener('click', onCloseHandler);

    });

    return close;

  }



  function setGiftBody(dto, cfg, extra) {

    var gift = document.getElementById('rl-notify-gift');

    if (!gift) return;

    var titleEl = gift.querySelector('.rl-notify-gift__title');

    var textEl = gift.querySelector('.rl-notify-gift__text');

    var title = giftTitleFor(dto, cfg);

    var body = messageFor(dto, cfg, extra);

    if (titleEl) titleEl.textContent = title;

    if (textEl) {

      var hi = formatPoints((dto.payload && dto.payload.points) || 0);

      var html = body.replace(

        new RegExp(hi.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),

        '<span class="highlight">' + hi + '</span>'

      );

      textEl.innerHTML = html;

    }

  }



  function appendVipLink(cfg, giftEl) {

    giftEl = giftEl || document.getElementById('rl-notify-gift');

    if (!giftEl) return;

    var bodyEl = giftEl.querySelector('.rl-notify-gift__body');

    if (!bodyEl || bodyEl.querySelector('[data-rl-welcome-vip]')) return;

    var ws = (cfg && cfg.welcomeSignup) || {};

    var wrap = document.createElement('p');

    wrap.className = 'rl-notify-gift__vip-link-wrap';

    var a = document.createElement('a');

    a.className = 'rl-notify-gift__vip-link';

    a.href = (cfg && cfg.vipClubUrl) || '/pages/blovo-vip-club';

    a.textContent = ws.viewVip || 'View VIP Benefits';

    a.setAttribute('data-rl-welcome-vip', '');

    wrap.appendChild(a);

    bodyEl.appendChild(wrap);

  }



  function showVipLink(cfg) {

    appendVipLink(cfg);

  }



  function setGiftHint(gift, hint) {

    if (!gift) return;

    var bodyEl = gift.querySelector('.rl-notify-gift__body');

    var actions = document.getElementById('rl-notify-gift-actions');

    if (!bodyEl) return;

    var hintEl = bodyEl.querySelector('.rl-notify-gift__hint');

    if (!hint) {

      if (hintEl) hintEl.remove();

      return;

    }

    if (!hintEl) {

      hintEl = document.createElement('p');

      hintEl.className = 'rl-notify-gift__hint';

      if (actions) {

        bodyEl.insertBefore(hintEl, actions);

      } else {

        bodyEl.appendChild(hintEl);

      }

    }

    hintEl.textContent = hint;

  }



  function hideGiftActions() {

    var actions = document.getElementById('rl-notify-gift-actions');

    if (actions) {

      actions.hidden = true;

      actions.innerHTML = '';

    }

    var gift = document.getElementById('rl-notify-gift');

    setGiftHint(gift, '');

    if (gift) {

      gift.classList.remove('rl-notify-gift--coupon', 'rl-notify-gift--guest');

      var vipWrap = gift.querySelector('.rl-notify-gift__vip-link-wrap');

      if (vipWrap) vipWrap.remove();

    }

  }



  function showGiftEl(dto, cfg) {

    var root = document.getElementById('rl-notify-root');

    var gift = document.getElementById('rl-notify-gift');

    if (!root || !gift) return Promise.resolve();

    hideGiftActions();

    root.hidden = false;

    setGiftBody(dto, cfg);

    gift.hidden = false;

    document.body.classList.add('rl-notify-gift-open');

    return new Promise(function (resolve) {

      bindGiftClose(gift, function () {

        if (dto && dto.kind === 'registration_bonus') {

          markRegistrationFlowCompleted();

        }

        resolve();

      });

    });

  }



  function showMonthlyCouponGift(dto, cfg) {

    var root = document.getElementById('rl-notify-root');

    var gift = document.getElementById('rl-notify-gift');

    var actions = document.getElementById('rl-notify-gift-actions');

    var payload = (dto && dto.payload) || {};

    var code = String(payload.discountCode || '').trim();

    if (!root || !gift || !actions || !code) {

      return showGiftEl(dto, cfg);

    }

    hideGiftActions();

    gift.classList.add('rl-notify-gift--coupon');

    root.hidden = false;

    setGiftBody(dto, cfg);

    var mc = cfg.monthlyCoupon || {};

    var coupon = document.createElement('div');

    coupon.className = 'rl-notify-coupon';

    var value = document.createElement('span');

    value.className = 'rl-notify-coupon__code';

    value.textContent = code;

    var copy = document.createElement('button');

    copy.type = 'button';

    copy.className = 'rl-notify-coupon__copy';

    copy.textContent = mc.copy || 'Copy coupon';

    copy.setAttribute('aria-label', (mc.copy || 'Copy coupon') + ': ' + code);

    copy.addEventListener('click', function () {

      copyText(code).then(function () {

        copy.textContent = mc.copied || 'Copied';

        copy.classList.add('is-copied');

        window.setTimeout(function () {

          copy.textContent = mc.copy || 'Copy coupon';

          copy.classList.remove('is-copied');

        }, 2200);

      }).catch(function () {

        showToastEl(mc.copy || 'Copy coupon', true);

      });

    });

    coupon.appendChild(value);

    coupon.appendChild(copy);

    var useNow = document.createElement('a');

    useNow.className = 'rl-notify-gift__btn rl-notify-gift__btn--primary';

    useNow.textContent = mc.useNow || 'Use coupon now';

    useNow.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cfg.cartUrl || '/cart');

    actions.appendChild(coupon);

    actions.appendChild(useNow);

    actions.hidden = false;

    var expiry = formatExpiry(payload.expiresAt);

    if (expiry) {

      setGiftHint(gift, applyPlaceholders(mc.expires || 'Valid through [[expires]]', dto));

    }

    gift.hidden = false;

    document.body.classList.add('rl-notify-gift-open');

    return new Promise(function (resolve) {

      bindGiftClose(gift, resolve);

    });

  }



  function appPopupActive() {

    return !!(window.__RAYS_VIP_POPUP_APP_ACTIVE__ || document.querySelector('[data-rays-vip-popup-app]'));

  }



  function showGuestVipPrompt(cfg) {

    var root = document.getElementById('rl-notify-root');

    var gift = document.getElementById('rl-notify-gift');

    var actions = document.getElementById('rl-notify-gift-actions');

    var gp = (cfg && cfg.guestPrompt) || {};

    if (appPopupActive() || !root || !gift || !actions || gp.enabled === false || isLoggedIn()) {

      return Promise.resolve(false);

    }

    hideGiftActions();

    gift.classList.add('rl-notify-gift--guest');

    var title = gift.querySelector('.rl-notify-gift__title');

    var text = gift.querySelector('.rl-notify-gift__text');

    if (title) title.textContent = gp.title || 'A better member price is waiting';

    if (text) text.textContent = gp.body || 'Sign in or create your free VIP account to unlock member-only rewards.';

    var login = document.createElement('button');

    login.type = 'button';

    login.className = 'rl-notify-gift__btn rl-notify-gift__btn--primary js-rays-open-shopify-account';

    login.setAttribute('data-rl-open-login', '');

    login.setAttribute('aria-haspopup', 'dialog');

    login.textContent = gp.login || 'Sign in or join VIP';

    var benefits = document.createElement('a');

    benefits.className = 'rl-notify-gift__btn rl-notify-gift__btn--secondary';

    benefits.href = cfg.vipClubUrl || '/pages/blovo-vip-club';

    benefits.textContent = gp.benefits || 'Explore VIP benefits';

    actions.appendChild(login);

    actions.appendChild(benefits);

    actions.hidden = false;

    root.hidden = false;

    gift.hidden = false;

    document.body.classList.add('rl-notify-gift-open');

    return new Promise(function (resolve) {

      var closeGift = bindGiftClose(gift, function () {

        resolve(true);

      });

      login.addEventListener('click', function () {

        window.setTimeout(closeGift, 180);

      });

    });

  }



  function openRegistrationGiftModal(dto, cfg) {

    var root = document.getElementById('rl-notify-root');

    var gift = document.getElementById('rl-notify-gift');

    if (!root || !gift) return false;

    hideGiftActions();

    root.hidden = false;

    setGiftBody(dto, cfg);

    gift.hidden = false;

    document.body.classList.add('rl-notify-gift-open');

    showVipLink(cfg);

    return true;

  }



  function registrationGiftCloseHandler(resolve) {

    return function () {

      markRegistrationFlowCompleted();

      resolve();

    };

  }



  function welcomeOfferEligible(offer) {

    if (!offer) return false;

    if (offer.state === 'issued' || offer.state === 'revoked') return false;

    if (offer.eligible === false) return false;

    if (offer.waitingForPoints) return false;

    return offer.state === 'none';

  }



  function showRegistrationWelcomeGift(dto, cfg) {

    var root = document.getElementById('rl-notify-root');

    var gift = document.getElementById('rl-notify-gift');

    var actions = document.getElementById('rl-notify-gift-actions');

    if (!root || !gift || !actions || !window.RaysLoyalty) {

      return showGiftEl(dto, cfg);

    }



    var ws = cfg.welcomeSignup || {};

    var defaultHandle = cfg.welcomeSpendRuleHandle || 'welcome-signup-store-credit';



    return window.RaysLoyalty.getWelcomeAutoRedeem()

      .then(function (payload) {

        var enabled = payload && payload.enabled;

        var offer = payload && payload.offer;

        var handle =

          (offer && offer.spendRuleHandle) ||

          defaultHandle;



        if (enabled && offer && offer.state === 'issued') {

          markRegistrationFlowCompleted();

          return Promise.resolve();

        }



        if (!openRegistrationGiftModal(dto, cfg)) {

          return Promise.resolve();

        }



        if (!enabled || !welcomeOfferEligible(offer)) {

          return new Promise(function (resolve) {

            bindGiftClose(gift, registrationGiftCloseHandler(resolve));

          });

        }



        var hint = applyPlaceholders(ws.offerHint || '', dto, {

          storeCreditAmount: formatMoneyCents(offer.storeCreditCents),

          pointsCost: offer.pointsSpent,

        });

        setGiftHint(gift, hint);



        actions.hidden = false;

        actions.innerHTML =

          '<button type="button" class="rl-notify-gift__btn rl-notify-gift__btn--primary" data-rl-welcome-redeem>' +

          (ws.redeemCta || 'Redeem as store credit') +

          '</button>' +

          '<button type="button" class="rl-notify-gift__btn rl-notify-gift__btn--secondary" data-rl-welcome-keep>' +

          (ws.keepPoints || 'Keep my points') +

          '</button>';

        appendVipLink(cfg, gift);



        return new Promise(function (resolve) {

          var closeGift = bindGiftClose(gift, registrationGiftCloseHandler(resolve));

          var redeemBtn = actions.querySelector('[data-rl-welcome-redeem]');

          var keepBtn = actions.querySelector('[data-rl-welcome-keep]');



          if (keepBtn) {

            keepBtn.addEventListener('click', function () {

              closeGift();

            });

          }



          if (redeemBtn) {

            redeemBtn.addEventListener('click', function () {

              redeemBtn.classList.add('is-loading');

              redeemBtn.disabled = true;

              if (keepBtn) keepBtn.disabled = true;

              window.RaysLoyalty.postRedeem(handle)

                .then(function () {

                  var textEl = gift.querySelector('.rl-notify-gift__text');

                  if (textEl && ws.redeemSuccess) {

                    textEl.innerHTML = applyPlaceholders(ws.redeemSuccess, dto, {

                      storeCreditAmount: formatMoneyCents(offer.storeCreditCents),

                    }).replace(

                      formatMoneyCents(offer.storeCreditCents),

                      '<span class="highlight">' + formatMoneyCents(offer.storeCreditCents) + '</span>'

                    );

                  }

                  setGiftHint(gift, '');

                  actions.hidden = true;

                  actions.innerHTML = '';

                  appendVipLink(cfg, gift);

                  document.dispatchEvent(new CustomEvent('rays-loyalty:redeemed'));

                })

                .catch(function () {

                  if (ws.redeemError) {

                    showToastEl(ws.redeemError, true);

                  }

                  redeemBtn.classList.remove('is-loading');

                  redeemBtn.disabled = false;

                  if (keepBtn) keepBtn.disabled = false;

                });

            });

          }

        });

      })

      .catch(function () {

        if (!openRegistrationGiftModal(dto, cfg)) {

          return Promise.resolve();

        }

        return new Promise(function (resolve) {

          bindGiftClose(gift, registrationGiftCloseHandler(resolve));

        });

      });

  }



  function shouldSkipVisitPoll(dto, cfg) {

    if (!dto || dto.kind !== 'visit') return false;

    var dedupe = cfg.visitDedupeMs || 12000;

    if (Date.now() - lastVisitToastAt < dedupe) return true;

    if (recentVisitAckIds[dto.id]) return true;

    return false;

  }



  function presentOne(dto, cfg) {

    if (!dto || !dto.id) return Promise.resolve();

    if (shouldSkipRegistrationNotification(dto)) {

      return ackIds([dto.id]);

    }

    if (shouldSkipVisitPoll(dto, cfg)) {

      recentVisitAckIds[dto.id] = true;

      return ackIds([dto.id]);

    }

    var isGift = !!GIFT_KINDS[dto.kind];

    var p;

    if (dto.kind === 'registration_bonus') {

      markRegistrationPresented(dto);

      ackIds([dto.id]);

      p = showRegistrationWelcomeGift(dto, cfg);

    } else if (dto.kind === 'monthly_vip_coupon') {

      p = showMonthlyCouponGift(dto, cfg);

    } else if (isGift) {

      p = showGiftEl(dto, cfg);

    } else {

      p = showToastEl(messageFor(dto, cfg), false);

    }

    if (dto.kind === 'visit') {

      lastVisitToastAt = Date.now();

    }

    return p.then(function () {

      return ackIds([dto.id]);

    });

  }



  function drainQueue(cfg) {

    if (showing || !queue.length) return;

    showing = true;

    var next = queue.shift();

    presentOne(next, cfg).finally(function () {

      showing = false;

      drainQueue(cfg);

    });

  }



  function debugEnabled() {

    try {

      if (/[?&]rl_debug=1(?:&|$)/.test(window.location.search || '')) return true;

    } catch (e) {}

    return false;

  }



  function debugLog() {

    if (!debugEnabled()) return;

    try {

      var args = ['[RL notify]'].concat([].slice.call(arguments));

      console.log.apply(console, args);

    } catch (e) {}

  }



  function notificationPriority(kind) {

    if (kind === 'registration_bonus') return 0;

    if (kind === 'birthday_bonus' || kind === 'birthday_gift_card') return 1;

    if (kind === 'monthly_vip_coupon') return 2;

    if (kind === 'monthly_tier_grant') return 3;

    if (kind === 'visit') return 10;

    return 5;

  }



  function sortNotifications(list) {

    return list.slice().sort(function (a, b) {

      var pa = notificationPriority(a && a.kind);

      var pb = notificationPriority(b && b.kind);

      if (pa !== pb) return pa - pb;

      var ta = a && a.createdAt ? Date.parse(a.createdAt) : 0;

      var tb = b && b.createdAt ? Date.parse(b.createdAt) : 0;

      return ta - tb;

    });

  }



  function handleSessionGrants(payload) {

    debugLog('session-grants', payload);

    if (!payload || payload.error) return;

    var cfg = readConfig();

    if (!cfg.enabled) return;

    var list = payload.notifications;

    if (list && list.length) {

      list = list.filter(function (dto) {

        return !shouldSkipRegistrationNotification(dto);

      });

      enqueueList(sortNotifications(list), cfg);

      return;

    }

    var granted = Number(payload.granted) || 0;

    if (granted > 0) {

      api.toastVisitGranted(granted);

    }

  }



  function enqueueList(list, cfg) {

    if (!list || !list.length) return;

    list.forEach(function (dto) {

      if (!dto || !dto.id || dto.acknowledged) return;

      // The App Embed owns monthly coupon presentation and acknowledgement.
      if (dto.kind === 'monthly_vip_coupon' && appPopupActive()) return;

      if (shouldSkipRegistrationNotification(dto)) {

        ackIds([dto.id]);

        return;

      }

      for (var i = 0; i < queue.length; i++) {

        if (queue[i] && queue[i].id === dto.id) return;

        if (dto.kind === 'registration_bonus' && queue[i] && queue[i].kind === 'registration_bonus') {

          return;

        }

      }

      queue.push(dto);

    });

    drainQueue(cfg);

  }



  function poll() {

    var cfg = readConfig();

    if (!cfg.enabled || !window.RaysLoyalty || !window.RaysLoyalty.getRewardNotifications) {

      return Promise.resolve();

    }

    if (document.visibilityState === 'hidden') return Promise.resolve();
    if (pollRequest) return pollRequest;

    var runRequest = function () {
      var ensure = window.RaysLoyalty.ensureCustomerId
        ? window.RaysLoyalty.ensureCustomerId()
        : Promise.resolve(customerId());

      var waitToken =
        window.RaysLoyalty.waitForStorefrontCustomerAccessToken
          ? window.RaysLoyalty.waitForStorefrontCustomerAccessToken({
              maxAttempts: 20,
              delayMs: 250,
            })
          : Promise.resolve('');

      return waitToken

      .then(function () {

        if (window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {

          window.RaysLoyalty.syncStorefrontTokenFromWebComponents();

        }

        return ensure;

      })

      .catch(function () {

        return '';

      })

      .then(function () {

        return window.RaysLoyalty.getRewardNotifications({ unacknowledged: true });

      })

      .then(function (data) {

        if (!data) return;

        var list = (data && data.notifications) || [];

        enqueueList(sortNotifications(list), cfg);

      })

      .catch(function () {});
    };

    var sharedRequest = window.RaysLoyalty.runCrossTabOnce
      ? window.RaysLoyalty.runCrossTabOnce('notification-poll', 10000, runRequest, 20000)
      : runRequest();
    pollRequest = Promise.resolve(sharedRequest).then(function (result) {
      pollRequest = null;
      return result;
    }, function (error) {
      pollRequest = null;
      throw error;
    });
    return pollRequest;

  }



  function pollAfterAuth(delayMs) {

    window.setTimeout(function () {

      if (window.RaysLoyalty && window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {

        window.RaysLoyalty.syncStorefrontTokenFromWebComponents();

      }

      poll();

    }, delayMs || 0);

  }



  function schedulePoll() {

    var cfg = readConfig();

    if (!cfg.enabled) return;

    window.clearInterval(pollTimer);

    pollTimer = window.setInterval(poll, cfg.pollIntervalMs || 60000);

  }



  var GUEST_INTENT_KEY = 'rl_guest_vip_intent_v1';

  var GUEST_COOLDOWN_KEY = 'rl_guest_vip_prompted_v1';



  function storageRead(storage, key) {

    try {

      return JSON.parse(storage.getItem(key) || 'null');

    } catch (e) {

      return null;

    }

  }



  function markGuestIntent(type) {

    if (isLoggedIn()) return;

    try {

      sessionStorage.setItem(GUEST_INTENT_KEY, JSON.stringify({

        type: type,

        path: window.location.pathname,

        at: Date.now(),

      }));

    } catch (e) {}

  }



  function bindGuestIntentTracking() {

    document.addEventListener('click', function (event) {

      var target = event.target && event.target.closest ? event.target.closest('a, button, add-to-cart, input[type="submit"]') : null;

      if (!target) return;

      if (target.matches('[name="checkout"], [data-checkout], a[href*="/checkout"]')) {

        markGuestIntent('checkout');

        return;

      }

      if (target.matches('add-to-cart, [name="add"], [data-add-to-cart], product-form button[type="submit"], product-form input[type="submit"]')) {

        markGuestIntent('cart');

      }

    }, true);

    document.addEventListener('submit', function (event) {

      var form = event.target;

      if (!form || !form.getAttribute) return;

      var action = String(form.getAttribute('action') || '');

      if (action.indexOf('/checkout') >= 0 || form.querySelector('[name="checkout"]')) {

        markGuestIntent('checkout');

      } else if (action.indexOf('/cart/add') >= 0) {

        markGuestIntent('cart');

      }

    }, true);

  }



  function maybeShowGuestPrompt() {

    if (appPopupActive()) return;

    var cfg = readConfig();

    var gp = cfg.guestPrompt || {};

    if (gp.enabled === false || cfg.customerLoggedIn || isLoggedIn()) return;

    if (cfg.pageType === 'customers/login' || /\/account(?:\/|$)/.test(window.location.pathname)) return;

    if (/\/pages\/blovo-vip-club(?:\/|$)/.test(window.location.pathname)) return;

    var intent = storageRead(sessionStorage, GUEST_INTENT_KEY);

    if (!intent || !intent.at || Date.now() - Number(intent.at) > (gp.intentTtlMs || 7200000)) return;

    if (intent.type !== 'checkout' && intent.path === window.location.pathname) return;

    var last = storageRead(localStorage, GUEST_COOLDOWN_KEY);

    if (last && Number(last.at) && Date.now() - Number(last.at) < (gp.cooldownMs || 604800000)) return;

    if (showing) {

      window.setTimeout(maybeShowGuestPrompt, 1800);

      return;

    }

    try {

      localStorage.setItem(GUEST_COOLDOWN_KEY, JSON.stringify({ at: Date.now(), type: intent.type }));

      sessionStorage.removeItem(GUEST_INTENT_KEY);

    } catch (e) {}

    showGuestVipPrompt(cfg);

  }



  function scheduleGuestPrompt(delayMs) {

    window.setTimeout(maybeShowGuestPrompt, typeof delayMs === 'number' ? delayMs : 350);

  }



  var api = {

    toast: function (kindOrText, opts) {

      var cfg = readConfig();

      var text = kindOrText;

      if (opts && typeof kindOrText === 'string' && cfg.templates && cfg.templates[kindOrText]) {

        text = applyPlaceholders(cfg.templates[kindOrText], {

          kind: kindOrText,

          payload: opts,

        });

      }

      return showToastEl(String(text || ''), false);

    },

    toastError: function (text) {

      return showToastEl(String(text || ''), true);

    },

    toastVisitGranted: function (points) {

      lastVisitToastAt = Date.now();

      return api.toast('visit', { points: points });

    },

    poll: poll,

    handleSessionGrants: handleSessionGrants,

    showGuestVipPrompt: function () {

      return showGuestVipPrompt(readConfig());

    },

    debugStatus: function () {

      return {

        enabled: readConfig().enabled,

        customerId: customerId(),

        hasRoot: !!document.getElementById('rl-notify-root'),

        hasConfig: !!document.getElementById('rl-notify-config'),

        hasRaysLoyalty: !!window.RaysLoyalty,

        token:

          window.RaysLoyalty && window.RaysLoyalty.getStorefrontCustomerAccessToken

            ? window.RaysLoyalty.getStorefrontCustomerAccessToken()

            : '',

        queueLength: queue.length,

        showing: showing,

        pollInFlight: !!pollRequest,

      };

    },

    enqueueNotifications: function (list) {

      enqueueList(sortNotifications(list || []), readConfig());

    },

  };



  window.RaysLoyaltyNotify = api;



  document.addEventListener('DOMContentLoaded', function () {

    debugLog('boot');

    bindGuestIntentTracking();

    scheduleGuestPrompt();

    if (window.RaysLoyalty && window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {

      window.RaysLoyalty.syncStorefrontTokenFromWebComponents();

    }

    poll();

    schedulePoll();

    window.addEventListener('load', function () {

      pollAfterAuth(500);

    });

    document.querySelectorAll('shopify-account').forEach(function (host) {

      host.addEventListener('close', function () {

        pollAfterAuth(400);

        pollAfterAuth(1200);

        pollAfterAuth(2500);

      });

    });

  });



  document.addEventListener('rays-loyalty:customer-id', function () {

    poll();

  });



  document.addEventListener('rays-loyalty:account-sheet-close', function () {

    pollAfterAuth(400);

    pollAfterAuth(1200);

    pollAfterAuth(2500);

  });



  document.addEventListener('rays-loyalty:session-grants', function (ev) {

    debugLog('event session-grants', ev && ev.detail);

    handleSessionGrants(ev && ev.detail);

  });



  document.addEventListener('rays-loyalty:redeemed', function () {

    markRegistrationFlowCompleted();

  });



  document.addEventListener('rays-loyalty:storefront-auth', function () {

    debugLog('event storefront-auth');

    pollAfterAuth(300);

    pollAfterAuth(1200);

    pollAfterAuth(2500);

  });



  window.addEventListener('pageshow', function () {

    scheduleGuestPrompt(250);

  });



  document.addEventListener('visibilitychange', function () {

    if (document.visibilityState === 'visible') {

      scheduleGuestPrompt(250);
      poll();

    }

  });

})();
